import React from 'react';

import PayForPrimePlanCafeBazaar from '@src/api/PayForPrimePlanCafeBazaar';
import { SubscriptionId } from '@src/enums';

import useAxiosErrorHandler from './useAxiosErrorHandler';
import useAxiosRequestConfig from './useAxiosRequestConfig';
import useIsMounted from './useIsMounted';
import useRefreshPrimeStatus from './useRefreshPrimeStatus';

const usePayForPrimePlanCafeBazaar = () => {
  const refreshPrimeStatus = useRefreshPrimeStatus();
  const axiosRequestConfig = useAxiosRequestConfig();
  const axiosErrorHandler = useAxiosErrorHandler();
  const isMounted = useIsMounted();

  const [loading, setLoading] = React.useState(false);

  const makeRequest = React.useCallback(
    async (
      planId: string,
      packageName: string,
      purchaseToken: string,
      subscriptionId: SubscriptionId
    ): Promise<void> => {
      try {
        setLoading(true);
        const response = await PayForPrimePlanCafeBazaar(
          planId,
          {
            packageName,
            purchaseToken,
            subscriptionId,
          },
          axiosRequestConfig
        );
        if (response.status === 400) {
          // plan already purchased from cafeBazaar
        } else if (response.status !== 200) {
          // another error occurred
        } else if (response.status === 200) {
          // plan successfully set for user
        } else {
          console.log(response);
        }
      } catch (e) {
        axiosErrorHandler(e);
      } finally {
        await refreshPrimeStatus();
        if (isMounted) {
          setLoading(false);
        }
      }
    },
    [axiosErrorHandler, axiosRequestConfig, isMounted, refreshPrimeStatus]
  );

  return React.useMemo(() => ({ makeRequest, loading, setLoading }), [
    loading,
    makeRequest,
  ]);
};

export default usePayForPrimePlanCafeBazaar;
